function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { loaded } from '../manager.js';
import bindEvents from '../utils/bindEvents.js';
import { bindProps, getPropsValues } from '../utils/bindProps.js';
import mountableMixin from '../utils/mountableMixin.js';
import TwoWayBindingWrapper from '../utils/TwoWayBindingWrapper.js';
import WatchPrimitiveProperties from '../utils/WatchPrimitiveProperties.js';
import { mappedPropsToVueProps } from './mapElementFactory.js';
var props = {
  zoom: {
    twoWay: true,
    type: Number
  },
  pov: {
    twoWay: true,
    type: Object,
    trackProperties: ['pitch', 'heading']
  },
  position: {
    twoWay: true,
    type: Object,
    noBind: true
  },
  pano: {
    twoWay: true,
    type: String
  },
  motionTracking: {
    twoWay: false,
    type: Boolean
  },
  visible: {
    twoWay: true,
    type: Boolean,
    default: true
  },
  options: {
    twoWay: false,
    type: Object,
    default: function _default() {
      return {};
    }
  }
};
var events = ['closeclick', 'status_changed'];
export default {
  mixins: [mountableMixin],
  props: mappedPropsToVueProps(props),
  replace: false,
  // necessary for css styles
  methods: {
    resize: function resize() {
      if (this.$panoObject) {
        google.maps.event.trigger(this.$panoObject, 'resize');
      }
    }
  },
  provide: function provide() {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _this.$panoPromiseDeferred = {
        resolve: resolve,
        reject: reject
      };
    });
    return {
      '$panoPromise': promise,
      '$mapPromise': promise // so that we can use it with markers

    };
  },
  computed: {
    finalLat: function finalLat() {
      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
    },
    finalLng: function finalLng() {
      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
    },
    finalLatLng: function finalLatLng() {
      return {
        lat: this.finalLat,
        lng: this.finalLng
      };
    }
  },
  watch: {
    zoom: function zoom(_zoom) {
      if (this.$panoObject) {
        this.$panoObject.setZoom(_zoom);
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return loaded.then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-street-view-pano']; // creating the map

      var options = _objectSpread({}, _this2.options, getPropsValues(_this2, props));

      delete options.options;
      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options); // binding properties (two and one way)

      bindProps(_this2, _this2.$panoObject, props); // binding events

      bindEvents(_this2, _this2.$panoObject, events); // manually trigger position

      TwoWayBindingWrapper(function (increment, decrement, shouldUpdate) {
        // Panos take a while to load
        increment();

        _this2.$panoObject.addListener('position_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('position_changed', _this2.$panoObject.getPosition());
          }

          decrement();
        });

        var updateCenter = function updateCenter() {
          increment();

          _this2.$panoObject.setPosition(_this2.finalLatLng);
        };

        WatchPrimitiveProperties(_this2, ['finalLat', 'finalLng'], updateCenter);
      });

      _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);

      return _this2.$panoPromise;
    }).catch(function (error) {
      throw error;
    });
  }
};